import React, { useEffect, useState } from "react";
import { FaRegEyeSlash, FaEye } from "react-icons/fa";
import { Formik, Form, Field } from "formik";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  requestBackgroundImage,
  requestLoginAction,
  setResetStateLogin,
} from "../../../Redux/LoginState/LoginActionCreator";
import { toast } from "react-toastify";
import { SignupSchema } from "../../../components/Helpers";
import { useSelector } from "react-redux";
import Uni_logo from "../../../Assets/DataCloud.jpeg";
import TextInput from "../../../components/TextInput";

function LoginForm() {
  const [isOpen, setIsOpen] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const [dynamicImage, setDynamicImage] = useState("");
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const LoginReducerState = useSelector((state) => state.LoginReducer);
  
  const loginAction = (values) => {
    dispatch(requestLoginAction(values));
  };
  
  const BackgroundImageReducer = useSelector((state) => state.FileReducer);

  useEffect(() => {
    if (LoginReducerState.loginResponse?.userDetails && !LoginReducerState.isLoading) {
      const userType = LoginReducerState.loginResponse.userDetails.acctType?.toUpperCase();
      if (userType === "ADMIN") {
        navigate("/", { replace: true });
        dispatch(setResetStateLogin());
      }
    } 

    if (LoginReducerState.loginResponse?.message && !LoginReducerState.isLoading) {
      setResetPassword(true);
    }

    // Handle error cases - reset form on error
    if (LoginReducerState.loginError && !LoginReducerState.isLoading) {
      // Reset form on error
      
      dispatch(setResetStateLogin());
    }
  }, [LoginReducerState, dispatch, navigate]);

  return (
    <div className="flex items-center justify-center w-[80vw] sm:w-[60vw] md:w-[20vw] p-3 md:px-5 bg-white rounded-2xl h-[50vh] sm:h-[55vh]">
    {!resetPassword ? (
      <Formik
        
        initialValues={{
          userName: "",
          password: "",
        }}
        validationSchema={SignupSchema}
        onSubmit={(values, { setSubmitting }) => {
          loginAction(values);
          setSubmitting(false);
        }}
        enableReinitialize={false}
      >
        {({ errors, touched, values, handleChange, isSubmitting }) => (
          <Form className="shadow-none w-full h-full mt-2 sm:mt-4">
            <div className="text-center mb-6 sm:mb-8">
              <div className="flex items-center justify-center mb-4">
                <img src={Uni_logo} alt="Logo" className="h-28 sm:h-32 w-auto object-contain hover:scale-105 transition-transform duration-300" />      
              </div>
              <h1 className="text-2xl sm:text-3xl font-bold text-cyan-900 mb-2">
                Welcome Back
              </h1>
              <p className="text-md sm:text-lg flex items-center justify-center mb-6 sm:mb-10">
                Please Sign in to continue
              </p>
            </div>
            <div className="mb-4">
              <TextInput
                type="text"
                placeholder="User Name"
                value={values.userName}
                name="userName"
                handleChange={handleChange}
                classes="w-full border border-gray-300 rounded-[0.3rem] p-2 h-[2.6rem]"
                legend
                bgColor="bg-white"
                isDisabled={LoginReducerState.isLoading}
              />
              {errors.userName && touched.userName ? (
                <p className="text-red-400">{errors.userName}</p>
              ) : null}
            </div>
            <div className="relative my-6 sm:my-8">
              <TextInput
                type={!isOpen ? "password" : "text"}
                placeholder="Password"
                handleChange={handleChange}
                value={values.password}
                name="password"
                classes="w-full border border-gray-300 rounded-[0.3rem] p-2 h-[2.6rem]"
                legend
                bgColor="bg-white"
                isDisabled={LoginReducerState.isLoading}
              /> 
              <span
                className="absolute right-2 top-3 flex items-center px-2 cursor-pointer"
                onClick={() =>  setIsOpen(!isOpen)}
              >
                {!isOpen ? <FaRegEyeSlash /> : <FaEye />}
              </span>
              {errors.password && touched.password ? (
                <p className="text-red-400">{errors.password}</p>
              ) : null}
            </div>
            <div className="mb-6 flex items-center justify-end">
              <Link className="flex text-primary mr-2 float-right" to={"/resetPassword"}>
                Forgot Password?
              </Link>
            </div>
            <button
              type="submit"
              disabled={LoginReducerState.isLoading || isSubmitting}
              className={`w-full text-white font-medium text-lg p-2 rounded transition-all duration-200 ${
                LoginReducerState.isLoading || isSubmitting
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-primary hover:bg-primaryDark"
              }`}
            >
              {LoginReducerState.isLoading || isSubmitting ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Signing in...
                </span>
              ) : (
                "Submit"
              )}
            </button>
          </Form>
        )}
      </Formik>
    ) : (
      <p>
        <Link className="text-primary" to="/resetPassword">
          Click here
        </Link>{" "}
        to reset your password{" "}
      </p>
    )}
  </div>
  
  );
}

export default LoginForm;
